import { FEATURE_KEYS, MODULE_KEYS, TELEMETRY_IDS } from '../routes/ids.js';
import { REPORTING_ROUTE_IDS } from '../routes/reporting-routes.js';
const loading = 'common.loading';
const empty = 'common.empty';
const error = 'common.error';
const forbidden = 'common.forbidden';
const notFound = 'common.notFound';
const degraded = 'common.degraded';
const stale = 'common.stale';
const states = {
    loading: { type: 'LOADING', titleKey: loading, messageKey: loading },
    empty: { type: 'EMPTY', titleKey: empty, messageKey: empty },
    error: { type: 'ERROR', titleKey: error, messageKey: error, retryable: true },
    forbidden: { type: 'FORBIDDEN', titleKey: forbidden, messageKey: forbidden },
    notFound: { type: 'NOT_FOUND', titleKey: notFound, messageKey: notFound },
    degraded: { type: 'DEGRADED', titleKey: degraded, messageKey: degraded },
    stale: { type: 'STALE', titleKey: stale, messageKey: stale },
};
function page(id, routeId, titleKey) {
    return {
        id,
        routeId,
        schemaVersion: 1,
        module: MODULE_KEYS.REPORTS,
        feature: FEATURE_KEYS.REPORTS_VIEW,
        telemetryId: TELEMETRY_IDS.REPORTS_VIEW,
        accessibilityLabelKey: titleKey,
        privacyClassification: 'CONFIDENTIAL',
        auditPolicy: 'ALWAYS',
        owner: 'investment-reporting-ux',
        availability: 'AVAILABLE',
        titleKey,
        layout: 'single',
        states,
        sections: [],
    };
}
export const REPORTING_PAGES = [
    page('page-reports-live', REPORTING_ROUTE_IDS.LIVE, 'reportsWorkspace.navigation.live'),
    page('page-reports-regulatory', REPORTING_ROUTE_IDS.REGULATORY, 'reportsWorkspace.navigation.regulatory'),
    page('page-reports-operations', REPORTING_ROUTE_IDS.OPERATIONS, 'reportsWorkspace.navigation.operations'),
    page('page-reports-operations-fixed-income', REPORTING_ROUTE_IDS.OPERATIONS_FIXED_INCOME, 'reportsWorkspace.operations.fixedIncome.title'),
    page('page-reports-operations-valuation-runs', REPORTING_ROUTE_IDS.OPERATIONS_VALUATION_RUNS, 'reportsWorkspace.operations.valuationRuns.title'),
    page('page-reports-operations-cutoff-controls', REPORTING_ROUTE_IDS.OPERATIONS_CUTOFF_CONTROLS, 'reportsWorkspace.operations.cutoffControls.title'),
];
